import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
// The brand's type, self-hosted so it is precached with the app (docs/26).
import '@fontsource/source-sans-3/latin-400.css';
import '@fontsource/source-sans-3/latin-600.css';
import '@fontsource/source-sans-3/latin-700.css';
import '@fontsource/saira-condensed/latin-600.css';
import '@fontsource/saira-condensed/latin-700.css';
import './styles/global.css';
import './styles/components.css';
import './styles/admin.css';
import './styles/diary.css';
import './styles/report.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
